const initContentData = async function ({ dispatch, commit }, { route, password }) {
    try {
        // transform slug
        const slug = route.path.replace(/^\//, '')
        const timeTravel = route.query.timeTravel ? `?timeTravel=${route.query.timeTravel}` : ''

        this.$timing.start('content-api')

        const config = {}
        if (password) {
            config.headers = { Authorization: password }
        }

        const response = await this.$axios.get(
            `${this.$config.platform.apis.cms}${slug}${timeTravel}`,
            config
        )

        this.$timing.end('content-api')

        // Make sure we have data (code defensively)
        if (!response?.data || (response?.data && Object.keys(response?.data).length === 0)) {
            throw new Error('No CMS data found')
        }

        await this.$storyblok.fetchAlgoliaData(response.data.story)

        // commit the merged content data into the store
        commit('setContentData', response.data)
    } catch (e) {
        // Password protected page
        if (e.response?.status === 401 && e.response?.data?.requiresAuth) {
            commit('setContentData', e.response.data)
            return
        }

        // If we are in storyblok, we don't want pages that aren't found to get sent to the 404 page.
        if (this.$storyblok.isPreview) return

        // 404/500 because either the page was not found or something bad happened
        this.$axiosError()
    } finally {
        await this.$storyblok.getPreviewStory()
    }
}

export default {
    initContentData,
}
